import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import GraphicsContainer from './GraphicsContainer';
import GraphicsStaticContainer from './GraphicsStaticContainer';
import FilterContainer from './FilterContainer';

import './styles.css';
//contenedor lado derecho del dashboard 
export default class HocGraphicsFilters extends Component {
  render() {
    return (
      <Grid className='chartBlock' >
        <Grid className='chartShow'>
          <FilterContainer />
        </Grid>
        {
          this.props.firstLoad ?
            <GraphicsStaticContainer
              dataResult={this.props.guagesResult}
              openDialog={this.props.openDialog}
              onClickGraphic={this.props.onClickGraphic}
              anchoMap={this.props.anchoMap} /> :
            <Grid className='chartAll'>
              <GraphicsContainer
                topcomuna={this.props.topcomuna}
                totales={this.props.totales}
                donas={this.props.donas}
                lineas={this.props.lineas}
                matrices={this.props.matrices}
                tops={this.props.tops}
                timeHorasResult={this.props.timeHorasResult}
                timeEdadResult={this.props.timeEdadResult}
                openDialog={this.props.openDialog}
                onClickGraphic={this.props.onClickGraphic}
                // onClickDate={this.props.onClickDate}
                anchoMap={this.props.anchoMap}
              />
            </Grid>
        }
      </Grid>
    )
  }
}
